export enum WindAuthAction {
  DeployModel = 'deploy_model',
  RunInference = 'run_inference',
  TrainModels = 'train_models',
  ViewModels = 'view_models',
}
